import { create } from 'zustand';

export type ToastTone = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: number;
  tone: ToastTone;
  title?: string;
  message: string;
  duration: number;
}

interface ToastState {
  toasts: Toast[];
  push: (toast: Omit<Toast, 'id' | 'duration'> & { duration?: number }) => number;
  dismiss: (id: number) => void;
}

let counter = 0;

/** Сколько держать тост без явного срока: короткий — 4,2 с, длинный — дольше, чтобы успеть прочитать три строки
 *  (прогон тестировщика 28.10: тост грамматики исчезал раньше), не больше 10 с. */
export function toastDuration(title: string | undefined, message: string): number {
  const length = (title?.length ?? 0) + message.length;
  return Math.min(10_000, Math.max(4200, 1800 + length * 60));
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: ({ tone, title, message, duration = toastDuration(title, message) }) => {
    counter += 1;
    const id = counter;
    set((state) => ({ toasts: [...state.toasts, { id, tone, title, message, duration }] }));
    return id;
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));

export function toast(input: Omit<Toast, 'id' | 'duration'> & { duration?: number }): number {
  return useToastStore.getState().push(input);
}
